import { render, staticRenderFns } from "./ChangeRole.vue?vue&type=template&id=22afab1b&scoped=true&"
import script from "./ChangeRole.vue?vue&type=script&lang=js&"
export * from "./ChangeRole.vue?vue&type=script&lang=js&"
import style0 from "./ChangeRole.vue?vue&type=style&index=0&id=22afab1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22afab1b",
  null
  
)

export default component.exports